import { createSlice } from "@reduxjs/toolkit"
import { ApiRequest } from "src/models/api.request";
import VwDrhakedissorguDTO from "src/models/DrHAkedis/VwDrhakedissorguDTO";
import VwHbsHakedis1DTO from "src/models/DrHAkedis/VwHbsHakedis1DTO";
import VwHastamuracaatizlemDTO from "src/models/MuracaatIzlem/VwHastamuracaatizlemDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads"
import { helper } from "src/utils/helper";


export class IMuracaaatIzlemSearchType {
    basTarih: string = helper.startDate();
    bitTarih: string = helper.endDate();
    dogumYil: number = null;
    kurumIds: string = "";
    refDoktorIds: string = "";
    adi: string = "";
    soyadi: string = "";
    aileAdi: string = "";
    islemNo: number = null;
    organizasyonIds: string = "";
    sadeceBorcuOlan: boolean = false
    sonucuCikanlar: boolean = false
}


interface IMuracaatIzlemType {
    searchModel: IMuracaaatIzlemSearchType,
    submitForm: boolean,
    muracaatModel: VwHastamuracaatizlemDTO,
    islemSelectedRows: Array<string>,
    raporSorguId: number
}

const MuracaatIzlemSlice = createSlice<IMuracaatIzlemType, MapReducerPayloads<IMuracaatIzlemType, {
    // setState: IMuracaatIzlemType,
    setSearchModel: IMuracaaatIzlemSearchType,
    setSubmitForm: boolean,
    setMuracaatModel: VwHastamuracaatizlemDTO,
    setIslemSelectedRows: Array<string>,
    setRaporSorguId: number
}>>({
    name: "MuracaatIzlemState",
    initialState: {
        submitForm: true,
        searchModel: new IMuracaaatIzlemSearchType(),
        muracaatModel: null,
        islemSelectedRows: [],
        raporSorguId: null
    },
    reducers: {
        // setState: (state, action) => action.payload,
        setSearchModel: (state, action) => {
            state.searchModel = action.payload
        },
        setSubmitForm: (state, action) => {
            state.submitForm = action.payload
        },
        setMuracaatModel: (state, action) => {
            state.muracaatModel = action.payload
        },
        setIslemSelectedRows: (state, action) => {
            state.islemSelectedRows = action.payload
        },
        setRaporSorguId: (state, action) => {
            state.raporSorguId = action.payload
        }
    }
})

export default MuracaatIzlemSlice